import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';
import { CreateQuoteForm } from './CreateQuoteForm';

export function CreateQuoteModal({
	open,
	onOpenChange,
	onSuccess,
}: {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	onSuccess?: () => void;
}) {
	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="sm:max-w-md">
				<DialogHeader>
					<DialogTitle>New quote</DialogTitle>
					<DialogDescription>Create a new quote request.</DialogDescription>
				</DialogHeader>

				<CreateQuoteForm
					onCancel={() => onOpenChange(false)}
					onCreated={() => {
						onOpenChange(false);
						onSuccess?.();
					}}
				/>
			</DialogContent>
		</Dialog>
	);
}
